import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectModal } from 'redux-modal';
import PaymentCalculatorModal from './PaymentCalculatorModal';

class PaymentCalculatorModalWrapper extends Component {
	render() {
		const { name, isMobile } = this.props;
		const CalculatorModal = connectModal({ name })(PaymentCalculatorModal);
		return <CalculatorModal isMobile={isMobile} />;
	}
}

PaymentCalculatorModalWrapper.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	name: PropTypes.string.isRequired
};

export default PaymentCalculatorModalWrapper;
